import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgLeafFillIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="#7C9D00"
      d="M8.74 53.6c.544.513.712.105.85-.38.635-2.182 2.603-7.907 7.867-14.211 3.64-4.39 7.98-8.18 12.76-11.085.648-.376 2.614-1.689 2.382-.957-3.19 5.462-12.42 19.675-16.54 29.773-.451 1.346-.595 1.95.14 2.546 1.654.97 3.408 1.597 6.547 2.264 5.662 1.002 11.922.361 17.154-2.198 10.58-4.728 14.655-15.404 15.155-24.87.215-2.611.122-4.96.292-7.532.554-7.665 3.435-16.09 6.569-23.116.275-.78-.155-.985-.788-1.082-1.373-.238-4.013-.616-7.538-.727-7.817-.215-16.006.933-23.308 3.524-5.994 2.013-12.097 5.172-17.065 9.212-4.612 3.696-8.164 7.449-9.923 13.429-1.491 4.812-1.89 10.835-.143 15.582.893 2.406 2.13 4.838 3.5 7.008.68 1.082 1.36 2.084 2.079 2.81z"
    />
  </svg>
)
export default SvgLeafFillIcon
